export interface FlowInput {
  key: string;
  flow: RawFlow;
}

export interface RawFlow {
  errorMessages: string[];
  nodes: Node[];
  connections: FlowEdge[];
}

type blockType =
  | BlockType
  | "document_validation_with_face_recognition_segment";

// Node represents a node of the flow
export interface Node {
  nodeId: string;
  type: blockType;
  order: string;
  incomingMessage: string;
  outgoingMessage: string;
  variable: Variable;
  backgroundCheckInput: Record<string, Variable>;
  validationInput: Record<string, Variable>;
  conditionPaths: Record<string, string>;
}

// FlowEdge represents an edge between 2 nodes
export interface FlowEdge {
  source: string;
  target: string;
}

// FlowOutput represents the response return by the API when a flow is created
export interface FlowOutput {
  flowID: string;
  greeting: string;
  // errorMessages []string            `json:"error_messages"`
  // nodes         map[string]Node     `json:"nodes"`
  // connections   map[string][]string `json:"connections"`
  // creationDate  time.Time           `json:"creation_date"`
  // updateDate    time.Time           `json:"update_date"`
}

export const buildFlowInput = (deployKey: string, flow: Flow): FlowInput => {
  const nodes: Node[] = [];
  const connections: FlowEdge[] = [];

  flow.nodes.forEach((node) => {
    const conditionPaths = node.data?.conditionPaths || {};
    let nodeType = node.type as blockType;

    if (
      node.type === "document_validation_segment" ||
      node.type === "email_validation_segment" ||
      node.type === "phone_validation_segment"
    ) {
      flow.edges.map((edge) => {
        if (edge.source !== node.id) {
          return;
        }

        switch (edge.data?.type) {
          case "success": {
            conditionPaths["success"] = edge.target;
            break;
          }
          case "failure": {
            conditionPaths["failure"] = edge.target;
            break;
          }
        }
      });
    }

    if (node.data?.validationInput?.faceValidation) {
      nodeType = "document_validation_with_face_recognition_segment";
    }

    nodes.push({
      nodeId: node.id,
      type: nodeType,
      order: node.data?.order?.toString() || "",
      incomingMessage: node.data?.incomingMessage?.toString() || "",
      outgoingMessage: node.data?.outgoingMessage?.toString() || "",
      variable: {
        key: node.data?.variable?.key || "",
        value: "",
        type: "string",
      },
      backgroundCheckInput: {
        first_name: {
          key:
            flow.variables?.get(
              node.data?.backgroundCheckInput?.firstName.variableID || ""
            )?.key || "",
          value: node.data?.backgroundCheckInput?.firstName.default || "",
          type: "string",
        },
        last_name: {
          key:
            flow.variables?.get(
              node.data?.backgroundCheckInput?.lastName.variableID || ""
            )?.key || "",
          value: node.data?.backgroundCheckInput?.lastName.default || "",
          type: "string",
        },
        national_id: {
          key:
            flow.variables?.get(
              node.data?.backgroundCheckInput?.nationalId.variableID || ""
            )?.key || "",
          value: node.data?.backgroundCheckInput?.nationalId.default || "",
          type: "string",
        },
        country: {
          key:
            flow.variables?.get(
              node.data?.backgroundCheckInput?.country.variableID || ""
            )?.key || "",
          value: node.data?.backgroundCheckInput?.country.default || "",
          type: "string",
        },
        type: {
          key:
            flow.variables?.get(
              node.data?.backgroundCheckInput?.type.variableID || ""
            )?.key || "",
          value: "person", // TODO: add this field to the form
          type: "string",
        },
        user_authorized: {
          key:
            flow.variables?.get(
              node.data?.backgroundCheckInput?.userAuthorized.variableID || ""
            )?.key || "",
          value: true, // TODO: add this field to the form
          type: "string",
        },
      },
      validationInput: {},
      conditionPaths,
    });
  });

  flow.edges.forEach((edge) => {
    connections.push({
      source: edge.source,
      target: edge.target,
    });
  });

  const errorMessages: string[] =
    flow.errorMessages?.map((errorMessage) => {
      return errorMessage.message;
    }) || [];

  const rawFlow: RawFlow = {
    errorMessages: errorMessages,
    nodes: nodes,
    connections: connections,
  };

  return {
    key: deployKey,
    flow: rawFlow,
  };
};
